import { WEB_COMPONENT_PORTAL_ID } from "@/components/views/imagine-web-components-wrapper";
import { CUSTOM_ELEMENT_TAG } from "@/web-components";

export function getPortalContainer() {
  return document
    .querySelector(CUSTOM_ELEMENT_TAG)
    ?.shadowRoot?.getElementById(WEB_COMPONENT_PORTAL_ID);
}
